import { Box } from "@mui/material";
import { HeroSliderWikifolioCard } from "src/components-mui/modules/hero-module/components/hero-slider-wikifolio-card";
import { IHeroSliderWikifolioData } from "src/components-mui/modules/hero-module/hero-slider-module.types";

const HERO_SLIDE_WIKIFOLIO_CARDS_SX = [
    {
        top: ["151px", "151px", "121px"],
        display: ["none", "block"],
    },
    {
        top: ["367px", "367px", "328px", "290px"],
        left: ["117px", "min(117px, calc(100% - 330px))", "117px", "min(376px, calc(100% - 290px))"],
        display: ["none", "block"],
    },
    {
        left: "184px",
        top: "482px",
        display: ["none", "none", "none", "block"],
    },
];

interface IHeroSliderWikifolioProps {
    wikifolios: IHeroSliderWikifolioData[];
}

export const HeroSliderWikifolios = ({ wikifolios }: IHeroSliderWikifolioProps) => {
    return (
        <Box
            sx={{
                position: "absolute",
                right: [0, 0, 0, "30px"],
                width: ["100%", "50%"],
                height: "100%",
                display: ["none", "block"],
            }}
        >
            {wikifolios.map((wf, i) => (
                <HeroSliderWikifolioCard key={i} {...wf} sx={{ position: "absolute", ...HERO_SLIDE_WIKIFOLIO_CARDS_SX[i] }} />
            ))}
        </Box>
    );
};
